<div class="featured-products-row-container" *ngIf="!!products && products.length > 0">
    <h2 class="featured-products-row-title heading-2">{{translatedTitle}}</h2>
    <product-card-carousel [products]="products" [showAddToCart]="showAddToCart"></product-card-carousel>
    <div class="add-all-container" *ngIf="showAddToCart">
        <div class="add-all-text" translate="cart.featured.all.addall.title" [useLocaleOverride]="useLocaleOverride"></div>
        <button type="button" class="button button-small button-grey" [ngClass]="addingAllToCart ? 'disabled-link' : ''" href="javascript:void(0)" (click)="addAllToCart()"
                translate="cart.featured.all.addtocart" [key]="'count'" [interpolate]="products.length" [useLocaleOverride]="useLocaleOverride">
        </button>
    </div>
</div>
